import http from '@/plugins/http';

const state = {
  smartVoiceDialogVisible: false,
  list: [],
  worksList: [],
  readers: []
}

const getters = {
  smartVoiceDialogVisible: state => state.smartVoiceDialogVisible,
  list: state => state.list,
  worksList: state => state.worksList,
  readers: state => state.readers
}

const mutations = {
  setSmartVoiceDialogVisible (state, flag) {
    state.smartVoiceDialogVisible = flag;
  },
  setList (state, list) {
    state.list = list;
  },
  setWorksList (state, list) {
    state.worksList = list;
  },
  setReaders (state, list) {
    state.readers = list;
  }
}

const actions = {
  isSmart ({state}, data) {
    return state.worksList.some(v => v.url === data.url);
  },
  async isRoleExisted ({state}, data) {
    let item = data && state.worksList.find(v => v.url === data.url);
    if (data && data.speaker) {
      item = data;
    }
    const existed = !!item;
    const {data: resp} = await http.get('/api/user/audioAI/source');
    const expired = item && !resp.data.some(v => v.sourceId === item.speaker);
    return {existed, expired};
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/smartVoice.js